import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Nav,
  NavItem,
  Button
} from "reactstrap";
import { Link } from "react-router-dom";

import Tabs from "react-responsive-tabs";

import Logo from "react-ionicons/lib/MdNotifications";
import Timeline from "./Components/Timeline";
import PushNotifications from "./Components/PushNotifications";

import * as pageActions from "../../../../reducers/PageOptions";
import api from "../../../../api";
import { fireSuccessAlert } from "../../Alerts/sweet";
import { unexpectedError, handleApiErrors } from "../../Alerts/errors";

const Options = ({ setPageLoading }) => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get("/assignment/totalNotSeen");

        setData(data);
      } catch (error) {
        handleApiErrors(error);
      }
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const getTabs = () => {
    return [{ title: "Mesaje", getContent: () => <Timeline data={data} /> }];
  };

  return (
    <UncontrolledDropdown onClick={() => setOpen(!open)}>
      <DropdownToggle className="p-0 mr-2" color="link">
        <div className="icon-wrapper icon-wrapper-alt rounded-circle">
          <div
            className="icon-wrapper-bg bg-danger d-flex justify-content-center"
            style={{ alignItems: "center" }}
          >
            <Logo
              beat={true}
              color="#d92550"
              fontSize="35px"
              icon="md-notifications-outline"
            />
          </div>
          <div className="badge badge-dot badge-dot-sm badge-danger">
            Notificari
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-xl rm-pointers">
        <div className="dropdown-menu-header mb-0">
          <div className="dropdown-menu-header-inner bg-deep-blue">
            <div
              className="menu-header-image opacity-1"
              style={
                {
                  // backgroundImage: "url(" + city3 + ")"
                }
              }
            />
            <div className="menu-header-content text-dark">
              <h5 className="menu-header-title">Notificari</h5>
              <h6 className="menu-header-subtitle mb-2">
                Ai <b>{data.length}</b> mesaje necitite
              </h6>
              <PushNotifications />
            </div>
          </div>
        </div>
        <Tabs
          tabsWrapperClass="body-tabs body-tabs-alt"
          transform={false}
          showInkBar={true}
          items={getTabs()}
        />
        <Nav vertical>
          <NavItem className="nav-item-divider" />
          <NavItem className="nav-item-btn text-center">
            <Link to="/agenda">
              <Button
                size="sm"
                className="btn-shadow btn-wide btn-pill"
                color="focus"
              >
                Vezi mesajele
              </Button>
            </Link>
          </NavItem>
        </Nav>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const mapDispatchToProps = dispatch => ({
  setPageLoading: loadingState =>
    dispatch(pageActions.setPageLoading(loadingState))
});

export default connect(null, mapDispatchToProps)(Options);
